import React, { useEffect } from 'react';
import { ButtonBase } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  bottomBoxComponentUpdate,
  GlobalHistory,
  showError,
  showSuccess,
  showWarn,
  sideMenuComponentUpdate,
  sideMenuIsOpenUpdate,
} from '../../../../Helper';
import { BulkUpdateProperties } from '../../../../Services';

export const BulkAssignActions = ({
  setPropertyStatus,
  propertyStatus,
  setIsLoading,
  errors,
  state,
  setIsSubmitted,
  parentTranslationPath,
  translationPath,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const cancelHandler = () => {
    GlobalHistory.goBack();
  };
  const saveHandler = async () => {
    setIsLoading(true);
    setIsSubmitted(true);
    if (errors && errors.length > 0) {
      showError(errors[0].message);
      setIsLoading(false);
      return;
    }
    const result = await BulkUpdateProperties(state);
    if (!(result && result.status && result.status !== 200)) {
      setPropertyStatus(result);
      if (result.success.length === 0 && result.failure.length > 0)
        showError(t(`${translationPath}properties-update-failed`));
      if (result.failure.length === 0 && result.success.length > 0) {
        showSuccess(t(`${translationPath}properties-updated-successfully`));
      }
      if (result.failure.length > 0 && result.success.length > 0) {
        showWarn(
          `${t(`${translationPath}number-of-properties-failed`)} : ${result.failure.length} / ${t(
            `${translationPath}number-of-properties-succeeded`
          )} : ${result.success.length}`
        );
      }
    } else showError('properties-update-failed');
    setIsLoading(false);
  };
  useEffect(() => {
    bottomBoxComponentUpdate(
      <div className='bulk-actions-wrapper w-100'>
        <ButtonBase className='btns c-danger' onClick={cancelHandler}>
          <span>{t(`${translationPath}cancel`)}</span>
        </ButtonBase>
        <ButtonBase className='btns theme-solid' onClick={saveHandler}>
          <span className='px-3'>
            {propertyStatus.failure.length > 0 ?
               t(`${translationPath}update-failed-properties`) :
               t(`${translationPath}save-changes`)}
          </span>
        </ButtonBase>
      </div>
    );
  });
  useEffect(
    () => () => {
      bottomBoxComponentUpdate(null);
      sideMenuComponentUpdate(null);
      sideMenuIsOpenUpdate(false);
    },
    []
  );
  return <div />;
};
